module.exports = __webpack_public_path__ + "img/select.f9f46922.jpg";